// extracted by mini-css-extract-plugin
export default {"tableHead":"PackageList_tableHead__ExnnB","tableBodyRow":"PackageList_tableBodyRow__o2lwA"};